import { render, staticRenderFns } from "./WyseRange.vue?vue&type=template&id=a2fa8b06&scoped=true&"
import script from "./WyseRange.vue?vue&type=script&lang=js&"
export * from "./WyseRange.vue?vue&type=script&lang=js&"
import style0 from "./WyseRange.vue?vue&type=style&index=0&id=a2fa8b06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2fa8b06",
  null
  
)

export default component.exports